define('models/trackerTagsDownload',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.TrackerTagsDownload = T1Model.extend({
    url: "tracker_tags/download.csv"
  });
  return T1.Models.TrackerTagsDownload;
});
